/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Content.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromFlow from 'Logic/ViewsFlow.js'
import ActionRequired from 'DesignSystem/ActionRequired/view.js'
import ButtonGrey from 'DesignSystem/ButtonGrey/view.js'
import Info from 'DesignSystem/Info/view.js'
import React from 'react'
import Title from 'DesignSystem/Title/view.js'
import { css } from "emotion"

let styles = {}
styles.Header = css({label: 'Header',
  flexDirection: "row",
height: 80})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
alignItems: "center",
paddingLeft: 50,
paddingRight: 50,
justifyContent: "space-between"})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row"})
styles.Vertical = css({label: 'Vertical',
  flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
overflowY: "auto",
alignItems: "center",
justifyContent: "center",
marginBottom: 50,
paddingLeft: 50,
paddingRight: 50})
styles.Vertical1 = css({label: 'Vertical1',
  flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
overflowY: "auto",
alignItems: "center",
justifyContent: "center",
marginBottom: 50,
paddingLeft: 50,
paddingRight: 50})
styles.Vertical2 = css({label: 'Vertical2',
  flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
overflowY: "auto",
alignItems: "center",
justifyContent: "center",
marginBottom: 50,
paddingLeft: 50,
paddingRight: 50})

export default function Content({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  isProviderAdmin,
isEmployerAdmin,
hasToAcceptAndSignAgreement,
onClickAcceptAndSignNextAgreement,
viewPath= "/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
}) {
    
    
    
    let flow = fromFlow.useFlow()
let setFlowTo = fromFlow.useSetFlowTo(viewPath)
    
    

  return (<React.Fragment
>
<div
 data-testid="Content.Header"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
 className={`views-block ${styles.Header}`}
>
<div
 data-testid="Content.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
 className={`views-block ${styles.Horizontal}`}
>
<Title
 data-testid="Content.Title"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
viewPath={`${viewPath}/Title`}
 text="Success!"
/>
<div
 data-testid="Content.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
 className={`views-block ${styles.Horizontal1}`}
>
<ButtonGrey
 data-testid="Content.ButtonGrey"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
viewPath={`${viewPath}/ButtonGrey`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/No")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/No")}
 text="Close"
 alignSelf="center"
/>
</div>
</div>
</div>
{
isProviderAdmin ? 
<div
 data-testid="Content.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
 className={`views-block ${styles.Vertical}`}
>
<Info
 data-testid="Content.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
viewPath={`${viewPath}/Info`}
 marginBottom={8}
 text="Time to finish setting up your profile. It's good to start by adding locations."
/>
<Info
 data-testid="Content.Info:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
viewPath={`${viewPath}/Info`}
 marginBottom={30}
 text="You will need at least one location to add professionals (providers)."
/>
<ActionRequired
 data-testid="Content.ActionRequired"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
viewPath={`${viewPath}/ActionRequired`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/MyLocations/Item/Content/Add")}
 text="Add locations"
/>
</div>
 : null
}
{
isEmployerAdmin ? 
<div
 data-testid="Content.Vertical:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
 className={`views-block ${styles.Vertical1}`}
>
<Info
 data-testid="Content.Info:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
viewPath={`${viewPath}/Info`}
 marginBottom={30}
 text="Time to finish setting up your profile. It's good to start by adding employees."
/>
<ActionRequired
 data-testid="Content.ActionRequired:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
viewPath={`${viewPath}/ActionRequired`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content")}
 text="Add employees to the plan"
/>
</div>
 : null
}
{
hasToAcceptAndSignAgreement ? 
<div
 data-testid="Content.Vertical:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
 className={`views-block ${styles.Vertical2}`}
>
<Info
 data-testid="Content.Info:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
viewPath={`${viewPath}/Info`}
 marginBottom={30}
 text="There are other companies pending that need your signature."
/>
<ActionRequired
 data-testid="Content.ActionRequired:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Confirmation/Content"
viewPath={`${viewPath}/ActionRequired`}
 onClick={onClickAcceptAndSignNextAgreement}
 text="Accept and Sign next agreement"
/>
</div>
 : null
}
{children}
</React.Fragment>)
}